import axios from 'axios'

export class MediaService {
  static downloadMedia = (
    url,
    filename,
    onProgress = (progressLoaded, progressTotal) => {},
    cancelTokenSource = axios.CancelToken.source()
  ) => {
    if (!filename) {
      filename = url.split('\\').pop().split('/').pop()
    }
    axios
      .get(url, {
        responseType: 'blob',
        cancelToken: cancelTokenSource.token,
        onDownloadProgress: (progress) => {
          onProgress(progress.loaded, progress.total)
        }
      })
      .then((response) => {
        const blob = window.URL.createObjectURL(new Blob([response.data]))
        MediaService.forceDownload(blob, filename)
      })
  }

  private static forceDownload(blob, filename) {
    const link = document.createElement('a')
    link.href = blob
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}
